const HOLDER_SELECTOR = '.om-holder, [id^="om-holder-"]';
const INPUT_SELECTOR = '.om-inputs, [name^="visitor["]';
const PATCH_FLAG = 'data-om-contrast-patched';
const LABEL_FLAG = 'data-om-label-patched';

const needsPatch = (el) => {
    if (el.hasAttribute(PATCH_FLAG)) return false;
    const s = getComputedStyle(el);
    if (s.backgroundImage !== 'none') return false;
    const bg = s.backgroundColor;
    if (!bg || bg === 'rgba(0, 0, 0, 0)' || bg === 'transparent') return false;
    return true;
};

const hasAccessibleName = (input) => {
    if (input.hasAttribute('aria-label') || input.hasAttribute('aria-labelledby')) return true;
    if (input.id && input.getRootNode().querySelector(`label[for="${CSS.escape(input.id)}"]`)) return true;
    return Boolean(input.closest('label'));
};

const labelFor = (input) => {
    const placeholder = input.getAttribute('placeholder')?.trim();
    if (placeholder) return placeholder;
    const name = input.getAttribute('name') || '';
    if (/email/i.test(name)) return 'Email';
    if (/phone/i.test(name)) return 'Phone';
    if (/name/i.test(name)) return 'Name';
    return 'Form input';
};

const labelizeInputs = (root) => {
    root.querySelectorAll(INPUT_SELECTOR).forEach((input) => {
        if (input.hasAttribute(LABEL_FLAG)) return;
        if (!hasAccessibleName(input)) input.setAttribute('aria-label', labelFor(input));
        input.setAttribute(LABEL_FLAG, '');
    });
};

const patch = (root) => {
    root.querySelectorAll('*').forEach((el) => {
        if (!needsPatch(el)) return;
        el.style.backgroundImage = 'linear-gradient(transparent, transparent)';
        el.setAttribute(PATCH_FLAG, '');
    });
    labelizeInputs(root);
};

const observeHolder = (holder) => {
    patch(holder);
    const observer = new MutationObserver(() => patch(holder));
    observer.observe(holder, { childList: true, subtree: true });
};

export default function bypassOptinmonkContrast() {
    const existing = document.querySelector(HOLDER_SELECTOR);
    if (existing) {
        observeHolder(existing);
        return;
    }
    const bootstrap = new MutationObserver(() => {
        const holder = document.querySelector(HOLDER_SELECTOR);
        if (!holder) return;
        observeHolder(holder);
        bootstrap.disconnect();
    });
    bootstrap.observe(document.body, { childList: true, subtree: true });
}
